<template>
  <v-speed-dial
    v-model="fab"
    bottom
    right
    direction="top"
    fixed
    transition="slide-y-reverse-transition"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="blue darken-2" dark fab>
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-developer-board</v-icon>
        <!-- {{ fab }} -->
      </v-btn>
    </template>
    <v-btn fab dark small color="green" @click="action(1)">
      <v-icon>mdi-form-select</v-icon>
    </v-btn>
    <v-btn fab dark small color="green" @click="action(2)">
      <v-icon>mdi-console</v-icon>
    </v-btn>
  </v-speed-dial>
</template>
<script>
export default {
  name: "DebugButton",
  components: {},
  watch: {
    fab: {
      handler() {
        if (!this.fab) {
          this.$store.dispatch("debug", "");
        }
      },
      deep: true
    }
  },
  data: () => ({
    fab: false
  }),
  methods: {
    action(type) {
      this.$store.dispatch("debug", type);
    }
  }
};
</script>
